import React, { useEffect, useState } from "react";
import Navbar from "../components/Cripsr/NavbarCrispr";
import NarrativeSection from "../components/phones/NarrativeSection";
import EndOfStoryNav from "../components/phones/EndOfStoryNav";
import BecauseScienceFooter from "../components/phones/BecauseScienceFooter";

// Replace these thumbs/banners with your real assets when ready
import phonesThumb from "../assets/images/hero/Hero Images.png";
import siliconThumb from "../assets/images/hero/Hero Images-02.png";
import foeThumb from "../assets/images/hero/Hero Images-04.png"
import privacyThumb from "../assets/images/hero/Hero Images-01.png";
import rechargingThumb from "../assets/images/hero/Hero Images-05.png";
import gutThumb from "../assets/images/hero/Hero Images-03.png";
import Yohannes from "../assets/images/chartoptions/Yohannes.jpg";
import TimelineScroll from "../components/phones/TimelineScroll";
import ArticleCredits from "../components/phones/ArticleCredits";

import img1 from "../assets/images/timeline/1_joordens_trinil_engravedshelledit.webp";
import img2 from "../assets/images/timeline/2_Lubang_Jeriji_Saléh_cave_painting_of_Bull.jpg";
import img3 from "../assets/images/timeline/3_Xerxes_Cuneiform_Van.JPG";
import img4 from "../assets/images/timeline/4_Hieroglyphs_from_the_tomb_of_Seti_I.jpg";
import img5 from "../assets/images/timeline/5_2013_0711_OracleShell_lead.jpg";
import img6 from "../assets/images/timeline/6_Rosetta_Stone.JPG";
import img7 from "../assets/images/timeline/7_Rökstenen_1.JPG";
import img8 from "../assets/images/timeline/8_Chodowiecki_Basedow_Tafel_21_c_Z.jpeg";
import img10 from "../assets/images/timeline/10_Morse_Telegraph_1837.jpg";
import img11 from "../assets/images/timeline/11_Alexander_Graham_Telephone_in_Newyork.jpeg";
import img12 from "../assets/images/timeline/12_Marconi's_first_radio_transmitter.jpeg";
import img13 from "../assets/images/timeline/13_RCA_630-TS_Television.jpg";
import img14 from "../assets/images/timeline/14_Telstar_satellite-CnAM_35181-IMG_5408-gradient.jpeg";
import img15 from "../assets/images/timeline/15_DynaTAC8000X.jpeg";
import img16 from "../assets/images/timeline/16_ai-generated-servers_g9ba329248_1280.jpg";
import img17 from "../assets/images/timeline/17_First_iPhone_Macworld_2007_DSCF1286.jpg";
import img18 from "../assets/images/timeline/18_Artificial Intelligence_iStock-1415186993.jpg"


const navLinks = [
    { label: "We love our phones", href: "/phones" },
    { label: "From stone to silicon", href: "/phones" },
    { label: "Friend or foe", href: "/phones/friendorfoe" },
    { label: "The privacy burden", href: "/phones/privacyburden" },
    { label: "Gut check", href: "/phones/gutcheck" },
    { label: 'Recharging', href: '/phones/recharging' },
];

// https://static-assets-because-science.s3.us-east-1.amazonaws.com/YOHANNES_60_Final+copy.mp4




const timelineItems = [
    {
        key: "t1",
        year: "500,000",
        suffix: "BCE",
        text: `
        <strong>Someone was here.</strong> Line etchings in bone, stone, wood and other materials… 
        These may date back more than 500,000 years to hominins which pre-date modern humans. 
        <a href="https://en.wikipedia.org/wiki/Trinil_shell" target="_blank" class="text-blue-600 underline">
          This shell
        </a> found on the Indonesian island of Java is etched with geometric lines, 
        which researchers believe were made between 540,000 and 430,000 years ago.
      `,
        image: img1, // replace with your imported image
        caption: "Image: Wim Lustenhouwer, VU University Amsterdam",
    },

    {
        key: "t2",
        year: "460,000",
        suffix: "years", // triggers disconnection layout
    },

    {
        key: "t3",
        year: "40,000",
        suffix: "BCE",
        text: `
        <strong>Cave paintings</strong> which include scenes created with charcoal, pigments and plant-based paints. 
        Probably the most well-known are those from the 
        <a href="https://en.wikipedia.org/wiki/Lascaux" target="_blank" class="text-blue-600 underline">Lascaux</a> and 
        <a href="https://en.wikipedia.org/wiki/Chauvet_Cave" target="_blank" class="text-blue-600 underline">Chauvet</a> caves in France. 
        Scientific dating estimates the oldest of these were made almost 40,000 years ago.
      `,
        image: img2, // replace with your imported image
        caption: "Depiction of a bull in the Lubang Jeriji Saléh limestone cave complex, dated to be around 40,000 years old."
    },
    {
        key: "t4",
        year: "35,000",
        suffix: "years", // triggers disconnection layout
    },

    {
        key: "t4",
        year: "5,000",
        suffix: "BCE",
        text: `
        <strong>Cuneiform</strong> is a 
        <a href="https://en.wikipedia.org/wiki/Cuneiform" target="_blank" class="text-blue-600 underline">script</a>, 
        believed to have started with the use of lines and wedges made in wet clay. 
        It was used to write several languages in the ancient Middle East. 
        The earliest examples were created about 5,000 years ago.
      `,
        image: img3, // replace with your imported image
        caption: "A large cuneiform inscription found on the south side of the Van Castle hill, in eastern Turkey. It’s several metres tall and wide, 25 centuries old and the message comes from the Persian king Xerxes. Image: Bjørn Christian Tørrissen"
    },


    {
        key: "t5",
        year: "3,400 - 3,200",
        suffix: "BCE",
        text: `
        <strong>Egyptian hieroglyphs</strong> came into use at about the same 
        <a href="https://en.wikipedia.org/wiki/Egyptian_hieroglyphs" target="_blank" class="text-blue-600 underline">time</a> as cuneiform.
      `,
        image: img4, // replace with your imported image
        caption: "Fragment of a wall with hieroglyphs from the tomb of Seti I."
    },
    {
        key: "t6",
        video: {
            id: "https://static-assets-because-science.s3.us-east-1.amazonaws.com/BOYD_60_Final+copy.mp4", // Example YouTube ID (replace if different)
        },
        caption: "20 Years of Arizona State University (ASU)",
    },

    {
        key: "t7",
        year: "3,000",
        suffix: "BCE",
        text: `
          <strong>Chinese characters</strong> also known as <em>hanzi</em> also emerged about 5,000 years ago. 
          They are believed to be a form of writing which emerged from the use of simple pictures 
          to show objects, actions and ideas.
        `,
        image: img5, // Replace with your image path
        caption: "This is a replica of an oracle turtle shell with ancient Chinese oracle scripts inscribed on it. Photo was taken in July 2004 from an exhibit at Chabot Space and Science Center in Oakland, California."
    },

    {
        key: "t8",
        year: "1,700",
        suffix: "BCE",
        text: `
          <strong>Alphabets</strong> developed in several ancient cultures. The 
          <a href="https://en.wikipedia.org/wiki/History_of_the_alphabet" target="_blank" class="text-blue-600 underline">oldest</a> 
          is believed to be the letters used by the Canaanites in the Middle East, about 4,000 years ago. 
          The Greek 
          <a href="https://en.wikipedia.org/wiki/Greek_alphabet" target="_blank" class="text-blue-600 underline">alphabet</a> 
          is the origin of the Latin and Cyrillic alphabets.
        `,
        image: img6, // Replace with your image path
        caption: "The Rosetta Stone with inscription in Ancient Egyptian hieroglyphs, Demotic script and Greek scripts. Image: Hans Hillewaert"
    },

    {
        key: "t9",
        year: "1850",
        suffix: "years", // disconnection
    },

    {
        key: "t10",
        year: "150",
        suffix: "CE",
        text: `
          <strong>Runic writing</strong> emerged separately from alphabets. Some of the most studied 
          <a href="https://en.wikipedia.org/wiki/Runes" target="_blank" class="text-blue-600 underline">examples</a> 
          are those which came into use 2,000 years ago in Scandinavia.
        `,
        image: img7, // Replace with your image path
        caption: "An inscription using cipher runes, the Elder Futhark, and the Younger Futhark, on the 9th-century Rök Runestone in Sweden. Image: Bengt Olof Åradsson."
    },

    {
        key: "t11",
        year: "1436",
        suffix: "CE",
        text: `
          <strong>Printing press</strong> may date back to 800 BCE. In Europe, the Gutenberg press was invented in about 1440 CE. 
          Nearly 600 years before Gutenberg, Buddhist monks in China were pressing ink writings into paper.
        `,
        image: img8, // Replace with your image path
        caption: "Print from an engraving depicting the printing press process. Image: Daniel Niklaus Chodowiecki"
    },

    {
        key: "t12",
        year: "400",
        suffix: "years", // disconnection
    },
    {
        key: "t13",
        year: "1830–1850",
        suffix: "CE",
        text: `
          <strong>Telegraph and morse code</strong> evolved out of the 
          <a href="https://en.wikipedia.org/wiki/Morse_code" target="_blank" class="text-blue-600 underline">work</a> 
          of several scientists and inventors in Europe between 1830 and 1850.
        `,
        image: img10, // replace with your image
        caption: "Morse Telegraph (1837), historical collection of France Telecom. Image: Zubro"
    },

    {
        key: "t14",
        video: {
            id: "https://static-assets-because-science.s3.us-east-1.amazonaws.com/Gilby_60_Final+copy.mp4", // Example YouTube ID (replace if different)

        },
        caption: "20 Years of Arizona State University (ASU)"
    },

    {
        key: "t15",
        year: "1876",
        suffix: "CE",
        text: `
          <strong>The telephone</strong> also represents the 
          <a href="https://en.wikipedia.org/wiki/History_of_the_telephone" target="_blank" class="text-blue-600 underline">work</a> 
          of more than one inventor, beginning with Antonio Meucci in 1849. 
          Alexander Graham Bell patented the telephone and switchboard system in 1876.
        `,
        image: img11, // replace with your image
        caption: "Alexander Graham Bell on the telephone in New York (calling Chicago) in 1892."
    },

    {
        key: "t16",
        year: "1897",
        suffix: "CE",
        text: `
          <strong>Radio</strong>, such as what we listen to from local broadcasters, owes its evolution to discoveries in electromagnetism. 
          The <a href="https://en.wikipedia.org/wiki/History_of_radio" target="_blank" class="text-blue-600 underline">first</a> 
          radio broadcast is credited to Guglielmo Marconi in 1897.
        `,
        image: img12,
        caption: "Recreation of the first radio transmitter with a monopole antenna, built by Guglielmo Marconi in August 1895 during his development of radio communication."
    },

    {
        key: "t17",
        year: "1948",
        suffix: "CE",
        text: `
          <strong>Television</strong> uses radio waves to carry audio and pictures. 
          It was in <a href="https://en.wikipedia.org/wiki/History_of_television" target="_blank" class="text-blue-600 underline">development</a> 
          before World War II, and quickly went into wide use in the United States beginning in 1948.
        `,
        image: img13,
        caption: "RCA Model 630-TS television set seen in a museum. It was the first mass produced TV set and was sold in 1946 and 1947."
    },

    {
        key: "t18",
        year: "1957",
        suffix: "CE",
        text: `
          <strong>Communication satellites</strong> followed the 
          <a href="https://en.wikipedia.org/wiki/Telstar" target="_blank" class="text-blue-600 underline">success</a> 
          of AT&T’s Telstar in 1962. They enabled telephone and even television connections between continents.
        `,
        image: img14,
        caption: "Model of AT&T’s Telstar satellite, on display at Conservatoire national des arts et métiers in Paris, France."
    },

    {
        key: "t19",
        year: "1973",
        suffix: "CE",
        text: `
          <strong>Mobile phone.</strong> A mobile phone is a portable telephone that can make and receive calls over a radio frequency link. 
          On April 3, 1973, Martin Cooper, a Motorola researcher and executive, made the first mobile telephone call from handheld subscriber equipment, 
          placing a call to Dr. Joel Engel of Bell Labs, his rival.
        `,
        image: img15,
        caption: "The Motorola DynaTAC 8000X became the first commercially available handheld cellular mobile phone."
    },

    {
        key: "t20",
        year: "1983",
        suffix: "CE",
        text: `
          <strong>Internet.</strong> A new communications protocol was established called 
          Transfer Control Protocol/Internetwork Protocol (TCP/IP). January 1, 1983, is considered the official birthday of the Internet. 
          Prior to this, the various computer networks did not have a standard way to communicate with each other.
        `,
        image: img16,
        caption: "Internet data server racks (AI generated image)"
    },

    {
        key: "t21",
        year: "2007",
        suffix: "CE",
        text: `
          <strong>Smartphones.</strong> The iPhone was the first smartphone designed and marketed by Apple Inc. 
          It was officially announced on January 9, 2007, and was released in the U.S. on June 29, 2007.
        `,
        image: img17,
        caption: "First iPhone on display under glass at 2007 Macworld."
    },
    {
        key: "t22",
        video: {
            id: "https://static-assets-because-science.s3.us-east-1.amazonaws.com/Ranhorn_60_Final+copy.mp4", // Example YouTube ID (replace if different)

        },
        caption: "20 Years of Arizona State University (ASU)"
    },
    {
        key: "t21",
        year: "2023",
        suffix: "CE",
        text: `
          <strong>The machine age?</strong> The history of AI-generated content began in the1950s, when computer scientists first began exploring the idea of machine-generated language. The ChatGPT large language model was launched on November 30, 2022, by San Francisco–based OpenAI. 
        `,
        image: img18,
        caption: ""
    },

];




export default function StoneAndSilicon() {
    const [isShrunk, setIsShrunk] = useState(false);
    useEffect(() => {
        const onScroll = () => setIsShrunk(window.scrollY > 0);
        onScroll();
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <div className="relative w-full bg-white">
            {/* Navbar */}
            <Navbar isShrunk={isShrunk} navLinks={navLinks} />

            {/* Opener (audio + article body). No big hero image to match your screenshot */}
            <NarrativeSection
                id="gut-check"
                containerWidth="max-w-md"
                padY="py-10"
                centeredImage={{
                    src: siliconThumb,
                    alt: "Friend or foe hero",
                    widthClass: "w-[90%] sm:w-[85%]",
                }}
                content={[
                    // Audio block first (kept inside content so we don't change the component)
                    <div key="audio" className="text-center mb-8">
                        <p className="uppercase text-gray-500 text-xs tracking-wide mb-2">
                            Listen to this episode
                        </p>
                        <div className="flex justify-center">
                            <audio controls className="w-full max-w-md">
                                <source src="/audio/gut-check.mp3" type="audio/mpeg" />
                                Your browser does not support the audio element.
                            </audio>
                        </div>
                    </div>,

                    // Article copy (use/replace with your final text)
                    `Stone tools and smartphones have one thing in common, they both are products of technology, making each a uniquely human endeavor. These two “tools” represent the alpha and the omega in human technological evolution. Yet, while stone tools are looked upon as a bedrock in human development, a milepost in advancement, not everyone is convinced smartphones reach that level of evolutionary status.`,
                    `One-point-eight million years separate the two tools. But Yohannes Haile-Selassie, an Ethiopian anthropologist and authority on pre-Homo Sapiens hominids, sees an interesting and ominous thread between the two.`,
                    `“I feel like we're totally dependent on cell phones to live our lives,” says Haile-Selassie, the director of the Institute of Human Origins at Arizona State University. “If something happens to this technology, would we be able to survive? Would the world continue the way it does in its functioning? I doubt it,” he says.`,
                    `As an example, Haile-Selassie said there was a moment when he saw the draw our smartphone-obsessed technological present by witnessing his workforce in the harsh landscape of the Afar region of Ethiopia literally heading for the hills.`,

                ]}
            />
            <NarrativeSection
                id="recharge"
                containerWidth="max-w-md"
                padY="py-10"
                centeredImage={{
                    src: Yohannes,
                    alt: "From stone to silicon Hero Image.",
                    widthClass: "w-[50%] sm:w-[45%]",
                }}

                content={[
                    `“We did not have cell phones in Ethiopia 20 years ago. “As soon as cell phone era started, every local worker had one,” says Haile-Selassie of the workers who play an essential role in the search for ancient human tools and fossils.`,
                    `“And that was really a problem in terms of how we were doing our research, because everybody runs to the hilltops. Why are they going there? Because they’re looking for networks.”`,
                    `In contrast, our prehistoric kinfolk weren’t nearly as dependent on their technology as we are on ours. Haile-Selassie says of one of those hand axes, “early human ancestors were using this for a specific purpose, one thing, which is probably for cutting meat.”`,
                    `“If homo erectus did not have hand axe technology, would it have been able to survive,” he asks. “The answer is yes, because this was one part of their adaptive strategy. If they didn't have these tools, they could still survive with the other means they had.”`,
                    `“Whereas the phone that we have today determines everything that we do, not only in terms of how we live, but also in terms of how we interact with other people,” Haile-Selassie explains. “We've got ourselves into a situation where we're very dependent on technology, which made ourselves so dependent on what we have in just in the palm of our hand,” he says.`


                ]}
            />

            {/* after second NarrativeSection, before ArticleCredits */}
            <TimelineScroll items={timelineItems} activeThreshold={0.45} />



            <ArticleCredits
                lines={[
                    "Written by David Rozul",
                    "Illustrations by Alex Davis",
                    "Audio narration by Deanna Dent",
                    "Sound design by Christopher Goulet",
                ]}
            />

            {/* Next + More (adjust routes/images as needed) */}
            <EndOfStoryNav
                nextChapter={{
                    href: "/friend-or-foe",
                    title: "Friend or foe",
                    imageSrc: foeThumb,
                    imageAlt: "Friend or Foe banner",
                }}
                more={[
                    { href: "/phones", title: "We love our phones", imageSrc: phonesThumb },
                    { href: "/privacy-burden", title: "The privacy burden", imageSrc: privacyThumb },
                    { href: "#gut", title: "Gut check", imageSrc: gutThumb },

                    { href: "/recharging", title: "Recharging", imageSrc: rechargingThumb },


                ]}
            />

            <BecauseScienceFooter />
        </div>
    );
}
